import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import {
  doctorAppointment,
  getDoctorSpecialities,
  doctorAppointmentListAvailable,
} from "../../../api/apiHandler";
import Header from "../../../components/header/Header";
import Footer from "../../../components/footer/Footer";
import $ from "jquery";

import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-buttons/js/dataTables.buttons.js";
import "datatables.net-buttons/js/buttons.colVis.js";
import "datatables.net-buttons/js/buttons.flash.js";
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";

import FeatherIcon from "feather-icons-react";
// import Tooltip from '@material-ui/core/Tooltip';
// import Tooltip from '@mui/material/Tooltip';
// import IconButton from '@material-ui/core/IconButton';
// import IconButton from '@mui/material/IconButton';
import Swal from "sweetalert2";
import { renderToStaticMarkup } from "react-dom/server";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import ReactDOM from "react-dom";
import Select from "react-select";

function DoctorAppointment() {
  const [doctorAppointmentList, setDoctorAppointmentList] = useState(null);
  const [doctorSpecialities, setDoctorSpecialities] = useState([]);
  const [totalRecordCount, setTotalRecordCount] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchSpecialityId, setSearchSpecialityId] = useState("");
  const [appointmentStatus, setAppointmentStatus] = useState(true);
  const [userRole, setUserRole] = useState("");

  // const handleChange = (e) => {
  //   setUserRole(e.target.value);
  // };
  useEffect(() => {
    if (searchQuery == "") {
      Swal.fire({
        title: "Please wait...",
        didOpen: () => {
          Swal.showLoading();
        },
      });
    }

    doctorAppointmentListAvailable({
      page: pageNo,
      record_count: perPage,
      search_text: searchQuery,
      search_speciality_id: searchSpecialityId,
      role: userRole,
    }).then((res) => {
      var response = JSON.parse(res);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        Swal.close();
        setDoctorAppointmentList(response.data.doctors);
        setTotalRecordCount(
          Math.ceil(response.data.total_record_count / perPage)
        );
      } else {
        setDoctorAppointmentList([]);
      }
    });
  }, [searchQuery, searchSpecialityId, pageNo, userRole]);

  useEffect(() => {
    getDoctorSpecialities({}).then((response) => {
      response = JSON.parse(response);
      if (response.code == process.env.REACT_APP_SUCCESS) {
        response.data.map((item) => {
          const specilityObj = {
            label: item.name,
            value: item.id,
            icon: item.icon,
          };
          doctorSpecialities.push(specilityObj);
        });
        // setDoctorSpecialities(response.data)
      }
    });
  }, []);

  const handlePageClick = (event) => {
    setPageNo(event.selected + 1);
  };

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
  };

  const handleSearchSpecialityId = (data) => {
    // console.log("sss>>>>>>>>>>",data.value);
    setSearchSpecialityId(data.value);
  };

  if (doctorAppointmentList == null) return <> </>;

  return (
    <>
      <Header />
      <section className="doctorsec-pad">
        <div className="container">
          <div className="mt-4">
            <p className="font_22 font_600 mb-0">Manage Appointments </p>

            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/patient/home" className="font_14">
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active font_14"
                  aria-current="page"
                >
                  {" "}
                  Manage Appointments
                </li>
              </ol>
            </nav>
          </div>
          <div className="card">
            <div className="card-body doctor-table-card">
              <div
                className="tab-pane fade show active"
                id="pills-home"
                role="tabpanel"
                aria-labelledby="pills-home-tab"
              >
                <div className="table-responsive">
                  <div className="row  ">
                    {/* Tabs */}
                    <div className=" col-md-5">
                      <ul
                        className="nav nav-pills   flex-wrap rounded p-2 commonTabs"
                        style={{
                          background: "#e3e3e3",
                          maxWidth: "max-content",
                        }}
                        id="pills-tab"
                        role="tablist"
                      >
                        <li className="nav-item" role="presentation">
                          <Link
                            to="/patient/appointment"
                            className="nav-link  active"
                          >
                            Manage Appointments
                          </Link>
                        </li>
                        <li className="nav-item" role="presentation">
                          <Link
                            to="/patient/my-appointments"
                            className="nav-link  "
                          >
                            My Appointments
                          </Link>
                        </li>
                      </ul>
                    </div>

                    {/* Select */}
                    <div className=" col-md-2">
                      <label
                        htmlFor="statusFilter"
                        className="d-block mb-1"
                        style={{ fontSize: "14px" }}
                      >
                        Choose Appointment:
                      </label>
                      <select
                        className="form-select"
                        value={userRole}
                        onChange={(e) => setUserRole(e.target.value)}
                      >
                        <option value="">Doctor/Clergy</option>
                        <option value="2">Doctor</option>
                        <option value="4">Clergy</option>
                      </select>
                    </div>

                    {/* Search & Filter */}
                    <div className=" col-md-5">
                      <div className="d-flex flex-column flex-md-row gap-2 gap-md-3">
                        {/* Search */}
                        <div className="flex-fill">
                          <label
                            htmlFor="search"
                            className="d-block mb-1"
                            style={{ fontSize: "14px" }}
                          >
                            Search by:
                          </label>
                          <input
                            id="search"
                            className="form-control"
                            type="text"
                            placeholder="Name or Email"
                            value={searchQuery}
                            onChange={handleSearch}
                          />
                        </div>

                        {/* Specialization */}
                        {userRole != "4" && (
                          <div className="flex-fill">
                            <label
                              htmlFor="specialization"
                              className="d-block mb-1"
                              style={{ fontSize: "14px" }}
                            >
                              Filter by Specialization:
                            </label>
                            <Select
                              id="specialization"
                              className="react-select__menu"
                              classNamePrefix="select"
                              name="specialization"
                              options={doctorSpecialities}
                              onChange={handleSearchSpecialityId}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <table
                    id="mangeUser"
                    className="table table-hover dataTable js-exportable"
                  >
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Phone Number</th>
                        <th>Email Address</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {doctorAppointmentList &&
                        doctorAppointmentList.map((item, index) => {
                          return (
                            <tr id={item.id} key={index}>
                              <td>{item.id}</td>
                              <td>
                                <h3 className="doc-details">
                                  <div className="doc-profile">
                                    <img src={item.profile_image} alt="" />
                                  </div>
                                  {item.first_name} {item.middle_name}{" "}
                                  {item.last_name}
                                </h3>
                              </td>

                              <td>{item.country_code + " " + item.phone_no}</td>
                              <td>{item.email}</td>

                              <td>
                                <Link
                                  to={`/patient/appointment/${item.id}`}
                                  className="connect-btn"
                                >
                                  Book Appointment
                                </Link>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                  <ReactPaginate
                    breakLabel="..."
                    nextLabel=" > "
                    onPageChange={handlePageClick}
                    pageCount={totalRecordCount}
                    previousLabel=" < "
                    renderOnZeroPageCount={null}
                    containerClassName="pagination"
                    pageLinkClassName="page-link"
                    previousLinkClassName="page-link"
                    nextLinkClassName="page-link"
                    disabledClassName="disabled"
                    activeClassName="active"
                    activeLinkClassName="active-link"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default DoctorAppointment;
